import React from 'react';
import { motion } from 'framer-motion';
import { useFavorites } from '../hooks/useFavorites';

interface FavoriteButtonProps {
  productId: string | number;
  className?: string;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ productId, className = '' }) => {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(productId);

  return (
    <motion.button
      type="button"
      whileTap={{ scale: 0.85 }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(productId);
      }}
      aria-pressed={active}
      aria-label={active ? 'Remove from saved picks' : 'Save to your picks'}
      title={active ? 'Saved' : 'Save for later'}
      className={`inline-flex items-center justify-center h-9 w-9 rounded-full transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-sage-500 ${
        active ? 'bg-sage-600 text-cream-50' : 'bg-white/90 text-earth-500 hover:text-sage-700 shadow-sm'
      } ${className}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-4 w-4"
        fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={2}
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
      </svg>
    </motion.button>
  );
};

export default FavoriteButton;
